import React from 'react';

// onBlur необязателен: без него компонент ведёт себя ровно как раньше. Нужен
// газобетонной дозагрузке, где количество дотягивается до целого поддона в момент,
// когда менеджер закончил набирать, а не на каждой цифре.
function NumberInput({ value, onChange, onBlur, placeholder, allowDecimal = false, maxDecimals = 6 }) {
  
  const handleChange = (e) => {
    const inputValue = e.target.value;

    if (allowDecimal) {
      const normalizedValue = inputValue.replace(',', '.');
      const decimalPattern = new RegExp(`^\\d{0,10}([.]\\d{0,${maxDecimals}})?$`);
      if (normalizedValue === '' || decimalPattern.test(normalizedValue)) {
        onChange(normalizedValue);
      }
      return;
    }

    // Регулярное выражение для проверки: пустая строка, или число до 10 цифр без ведущих нулей (кроме 0)
    if (inputValue === '' || /^[0-9]{0,10}$/.test(inputValue)) {
      onChange(inputValue === '' ? '' : inputValue); // Передаём пустую строку или введённое число
    }
  };


  return (
    <input
      type="text"
      value={value} // Устанавливаем пустую строку, если value undefined или null
      onChange={handleChange}
      onBlur={onBlur}
      className="form-control fs-6"
      // placeholder={value === "" ? "1" : value}
    />
  );
}

export default NumberInput;
